import { CombineComponents } from "./CombineContext";
import { AuthProvider } from "./Components/auth";
import { LoaderProvider } from "./Components/loaderContext";
import { ToastProvider } from "./Components/notify";
import { SidebarProvider } from "./Components/sidebar";
import { CreditorsArtistProvider } from "./Components/CreditorsArstisState";

const providers = [
    ToastProvider,
    AuthProvider,
    LoaderProvider,
    SidebarProvider,
    CreditorsArtistProvider
]

export const AppContextProvider = CombineComponents(...providers)